<template lang="html">
  <v-dialog
    ref="dialog"
    v-model="modal"
    persistent
    width="290px"
  >
    <template #activator="{ on }">
      <v-btn
        v-bind="$attrs"
        text
        v-on="on"
      >
        {{ (displayRange || []).length > 0 ? displayRange.join(' - ') : 'select date range' }}
      </v-btn>
    </template>
    <v-date-picker
      v-model="dates"
      type="month"
      scrollable
      multiple
      :title-date-format="title"
      @click:month="monthClick"
    >
      <v-btn
        text
        color="primary"
        @click="setNow"
      >
        Now
      </v-btn>

      <v-spacer />
      <v-btn
        text
        color="primary"
        @click="cancel"
      >
        Cancel
      </v-btn>
    <!-- <v-btn text color="primary" @click="$refs.dialog.save(usageRangeDates)">OK</v-btn> -->
    </v-date-picker>
  </v-dialog>
</template>

<script>
import helpers from '@/mixins/helpers'
import { min, max } from 'lodash'
import moment from 'moment'

export default {
  mixins: [ helpers ],
  props: {
    value: Object,
    defaultSize: {
      type: [ String, Number ],
      default: 1
    },
    monthOnly: Boolean
  },
  data () {
    return {
      dates: [],
      modal: false,
      oldRange: [],
      internalRange: [],
      displayRange: []
    }
  },
  computed: {
    // ...mapGetters([]),
  },
  watch: {
    modal (v) {
      if (v) {
        this.oldRange = this.internalRange
        this.dates = []
        // this.internalRange = []
      }
      // if (!v && this.internalRange.length === 0) {
      //   this.internalRange = this.oldRange
      // }
    },
    internalRange: {
      handler () {
        let start, end

        this.displayRange = this.internalRange.map(d => { return moment(d).format('MMM-YYYY') })

        if (this.internalRange.length === 0) {
          if (this.monthOnly) {
            start = moment().startOf('month').subtract(Number(this.defaultSize) - 1, 'month').format('YYYYMMDD')
            end = moment().endOf('month').format('YYYYMMDD')
          } else {
            start = moment().subtract(this.defaultSize, 'month').format('YYYYMMDD')
            end = moment().format('YYYYMMDD')
          }
        } else {
          start = moment(this.startOfMonth(this.internalRange[0])).format('YYYYMMDD')
          end = moment(this.endOfMonth(this.internalRange[this.internalRange.length === 1 ? 0 : 1])).format('YYYYMMDD')
        }
        this.$emit('input', { start: start, end: end })
      },
      immediate: true
    }
  },
  methods: {
    startOfMonth (d) {
      let [y, m] = d.split('-')
      return moment(`${y}-${m}-01`)
    },
    endOfMonth (d) {
      let [y, m] = d.split('-')
      let days = moment(`${y}-${m}-01`).daysInMonth()
      return moment(`${y}-${m}-${days}`)
    },
    monthClick (e) {
      if ((this.internalRange || []).length === 1 && this.oldRange !== this.internalRange) {
        let firstDate = this.internalRange[0]
        if (e !== firstDate) this.internalRange = [min([e, firstDate]), max([e, firstDate])]
        this.modal = false
      } else {
        this.internalRange = [e]
      }
    },
    title () {
      return this.displayRange.join(' - ')
    },
    cancel () {
      this.internalRange = this.oldRange
      this.modal = false
    },
    setNow () {
      this.internalRange = []
      this.modal = false
    }
  }
}
</script>

<style lang="css" scoped>

</style>
